var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDownload(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z",
    fill: "#68E668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16a14 14 0 01-14 14V2a14 14 0 0114 14z",
    fill: "#54D154"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.614 18.665a5.494 5.494 0 01-5.538 4.996H9.906v-.056A6.222 6.222 0 018.44 11.632a6.832 6.832 0 014.575-5.04.828.828 0 011.086.784v6.972a.6.6 0 01-.593.599h-1.596a.6.6 0 00-.448 1.002l4.076 4.564a.559.559 0 00.46.19.56.56 0 00.43-.19l4.106-4.603a.6.6 0 00-.448-1.002h-1.574a.594.594 0 01-.605-.588V8.339a.828.828 0 011.339-.65 6.81 6.81 0 012.66 5.264h.358a5.36 5.36 0 015.348 5.712z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgDownload;